import React, {useState} from "react";
import styled from 'styled-components'
import {AnimatePresence, motion} from "framer-motion"

import Wave from './Wave'

const ProductsReveal = ({brand, logo, waveColor, baseBG, gradientBG, children, side}) => {
    const [toggle, setToggle] = useState(false);
    const [hovered, setHovered] = useState(false);

    return(
        <PrReveal layout
                className={`brand ${brand}`}
                onClick={() => setToggle(!toggle)}
                onMouseEnter={() => setHovered(true)}>

            <motion.div layout className="logo">
                <img src={logo} alt="" />
            </motion.div>

            {toggle && (
                <motion.div layout>
                    {children}
                </motion.div>
            )}

            <BgImg gradientBG={gradientBG}/>
            {hovered && <Wave hovered={hovered} color={waveColor}/>}
        </PrReveal>
    )
}

const PrReveal = styled(motion.div)`
    position: relative;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100vw;
    height: 85vh;
    display: flex;
    justify-content: space-around;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
`
const BgImg = styled(motion.div)`
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    width: 100%; height: 100%;
    background: ${props => props.gradientBG}
`
export default ProductsReveal;